import { type ButtonHTMLAttributes } from "react";
import clsx from "clsx";
import { EqualizerIcon } from "@/shared/assets/svg/icons";
import "./filters-button.scss";

interface FiltersButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

export const FiltersButton = ({
  active,
  className,
  children = "Фильтры",
  ...rest
}: FiltersButtonProps) => (
  <button
    {...rest}
    type="button"
    className={clsx("filters-button", active && "filters-button--active", className)}
  >
    <span>{children}</span>
    <EqualizerIcon className="filters-button__icon" />
  </button>
);
